import { useQuery } from '@tanstack/react-query';
import { fetchCarouselData } from 'api/cms/carousel';

import { REACT_QUERY_KEYS } from '.';

export function useCarousel(customerId?: string, forceEnabled?: boolean) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.homeKeys.CAROUSEL_LIST],
    queryFn: () => fetchCarouselData(),
    enabled: !!customerId || forceEnabled,
  });
}
